export function isValidationOptions(val) {
    if (!val) {
        return false;
    }
    return ('each' in val || 'message' in val || 'groups' in val || 'always' in val || 'context' in val || 'validateIf' in val);
}
//# sourceMappingURL=ValidationOptions.js.map